export default __webpack_public_path__ + "cvfelipe.pdf";